// Sticky bottom CTA on mobile (and desktop too) — always visible buy button.
// Hides on the hero (above the fold).
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import CPCountdown from "./CPCountdown";

export default function CPStickyCta({ onBuyClick }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="cp-sticky-cta"
      className="fixed bottom-0 left-0 right-0 z-30 bg-[#0A0A0A] border-t border-[#D4AF37]/30 px-4 py-3 backdrop-blur"
    >
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-3">
        <div className="text-white">
          <div className="flex items-baseline gap-2">
            <span className="text-xl sm:text-2xl font-extrabold text-[#D4AF37]">₹1,249</span>
            <span className="text-xs text-white/50 line-through hidden sm:inline">₹10,000</span>
          </div>
          <div className="text-[10px] uppercase tracking-wider text-white/60 mt-0.5">
            Ends in <CPCountdown compact />
          </div>
        </div>
        <Button
          data-testid="cp-sticky-buy-cta"
          onClick={onBuyClick}
          className="bg-[#D4AF37] hover:bg-[#E5C254] text-[#0A0A0A] font-extrabold text-sm sm:text-base px-5 sm:px-7 py-5 rounded-sm"
        >
          Activate Care+ →
        </Button>
      </div>
    </div>
  );
}
